module.exports = __webpack_public_path__ + "static/media/twaddan-react-white.95a0ab4b.png";